import { PageType } from 'templates/types';

export const isPlugin = (pageType: PageType): boolean => pageType === 'Plugin';
